module.exports = __webpack_public_path__ + "img/37478-257.6c8a6ba3.jpg";